import { ButtonContainer } from "./Button.styles";

const Button = ({
  title,
  onClick,
  leftIcon,
  rightIcon,
  style,
  disabled,
  opacity,
  loading,
  background,
  textColor,
}) => {
  return loading ? (
    <ButtonContainer
      style={style}
      disabled
      $background={background}
      $textColor={textColor}
      $opacity={opacity}
    >
      <l-bouncy size="22" speed="0.9" color={textColor || "#fff"} />
    </ButtonContainer>
  ) : (
    <ButtonContainer
      style={style}
      onClick={onClick}
      disabled={disabled}
      $background={background}
      $textColor={textColor}
      $opacity={opacity}
    >
      {leftIcon}
      {title}
      {rightIcon}
    </ButtonContainer>
  );
};

export default Button;
